import { clearHighlight } from "../direct.js";

export function findLayer(uid, layer_name, layer_index, layerNumberLimit, cls) {
  let svgElems = document.querySelectorAll("#view-" + uid + " svg g");
  let cls_name = { find: "dupo-g-found", hide: "dupo-g-hidden", unhide: "dupo-g-hidden" }[cls];
  if (layerNumberLimit > 1) {
    svgElems.forEach((g) => {
      if (
        g.classList.contains("role-mark") &&
        (g.className.baseVal.includes("__named_" + layer_name + "_") ||
          g.className.baseVal.includes(`F_layer_${layer_index}__mark_layer_${0}_marks`) ||
          g.className.baseVal.includes(`F_layer_${layer_index}__mark_layer_${1}_marks`))
      )
        Array.from(g.children).forEach((e) =>
          e.classList.add("dupo-g-found")
        );
    });
  } else {
    svgElems.forEach((g) => {
      if (
        g.classList.contains("role-mark") &&
        (g.className.baseVal.includes(uid + "_child_marks") ||
          g.className.baseVal.includes(`F_layer_${layer_index}__mark_layer_${0}_marks`) ||
          g.className.baseVal.includes(`F_layer_${layer_index}__mark_layer_${1}_marks`))
      )
        Array.from(g.children).forEach((e) => {
          if (cls === "unhide") { e.classList.remove(cls_name) }
          else { e.classList.add(cls_name) }
        }
        );
    });
  }
}
export function unfindLayer() {
  clearHighlight();
}